import { Component } from '@angular/core';

@Component({
  selector: 'qb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor() {}

  public currentYear(): number {
    return new Date().getFullYear();
  }
}
